module.exports = __webpack_public_path__ + "static/media/bar5.c0858cb5.jpg";